/**
 * Spin To Win - 转盘抽奖弹窗逻辑
 * 功能：
 * 1. 第一次访问：显示转盘弹窗
 * 2. 点击 SPIN 后：保存状态，下次直接显示结果
 * 3. 提交邮箱后：彻底隐藏抽奖功能
 * 4. 点击关闭后：变成左下角浮动按钮
 */

(function () {
  'use strict';

  // ============================================
  // 配置项
  // ============================================
  const CONFIG = {
    SEGMENTS: [
      { label: '10% OFF', value: 10, angle: 0 },
      { label: '15% OFF', value: 15, angle: 40 },
      { label: '5% OFF', value: 5, angle: 80 },
      { label: '15% OFF', value: 15, angle: 120 },
      { label: '10% OFF', value: 10, angle: 160 },
      { label: '5% OFF', value: 5, angle: 200 },
      { label: '15% OFF', value: 15, angle: 240 },
      { label: '10% OFF', value: 10, angle: 280 },
      { label: '5% OFF', value: 5, angle: 320 }
    ],
    TARGET_SEGMENT_INDEX: 0,
    MIN_SPINS: 5.11,
    SPIN_DURATION: 4000,
    STORAGE_KEY: 'stw_state',
    SHOW_DELAY: 1500
  };

  // ============================================
  // 状态管理（从 localStorage 读取）
  // ============================================
  let State = {
    hasSpun: false,      // 是否点击过 SPIN
    isClosed: false,     // 是否关闭过弹窗
    hasSubmitted: false, // 是否提交过邮箱
  };

  // ============================================
  // DOM 元素引用
  // ============================================
  const elements = {};

  // ============================================
  // 工具函数
  // ============================================

  function saveState() {
    try {
      localStorage.setItem(CONFIG.STORAGE_KEY, JSON.stringify(State));
    } catch (e) {
      console.warn('SpinToWin: 无法保存状态', e);
    }
  }

  function loadState() {
    try {
      const saved = localStorage.getItem(CONFIG.STORAGE_KEY);
      if (saved) {
        const data = JSON.parse(saved);
        State.hasSpun = data.hasSpun || false;
        State.isClosed = data.isClosed || false;
        State.hasSubmitted = data.hasSubmitted || false;
      }
    } catch (e) {
      console.warn('SpinToWin: 无法读取状态', e);
    }
  }

  function getElements() {
    elements.overlay = document.querySelector('.stw-overlay');
    elements.modal = document.querySelector('.stw-modal');
    elements.wheelView = document.querySelector('.stw-wheel-view');
    elements.result = document.querySelector('.stw-result');
    elements.success = document.querySelector('.stw-success');
    elements.wheel = document.querySelector('.stw-wheel');
    elements.spinBtn = document.querySelector('.stw-wheel__center');
    elements.closeBtns = document.querySelectorAll('.stw-close-btn');
    elements.floatingBtn = document.querySelector('.stw-floating-btn');
    elements.emailForm = document.getElementById('stw-email-form');
    elements.emailInput = document.querySelector('.stw-result__input');
    elements.emailError = document.querySelector('.stw-result__error');
  }

  // ============================================
  // 视图控制
  // ============================================

  function showModal() {
    if (elements.overlay) elements.overlay.classList.add('is-active');
    if (elements.modal) elements.modal.classList.add('is-active');
  }

  function hideModal() {
    if (elements.overlay) elements.overlay.classList.remove('is-active');
    if (elements.modal) elements.modal.classList.remove('is-active');
  }

  function showResult() {
    if (elements.wheelView) elements.wheelView.style.opacity = '0';
    if (elements.result) elements.result.classList.add('is-visible');
  }

  function showSuccess() {
    if (elements.success) elements.success.classList.add('is-visible');
  }

  function showFloatingBtn() {
    if (elements.floatingBtn) elements.floatingBtn.classList.add('is-visible');
  }

  function hideFloatingBtn() {
    if (elements.floatingBtn) elements.floatingBtn.classList.remove('is-visible');
  }

  // ============================================
  // 转盘逻辑
  // ============================================

  function handleSpin() {
    console.log('handleSpin called', State);
    
    if (State.hasSpun) {
      console.log('Already spun, showing result directly');
      if (elements.wheelView) elements.wheelView.style.opacity = '0';
      showResult();
      return;
    }

    // 移除脉冲动画
    if (elements.spinBtn) elements.spinBtn.classList.remove('is-pulsing');

    const segmentAngle = CONFIG.TARGET_SEGMENT_INDEX * (360 / CONFIG.SEGMENTS.length);
    const randomSpins = CONFIG.MIN_SPINS + Math.floor(Math.random() * 3);
    const targetRotation = randomSpins * 360 - segmentAngle;
    
    console.log('Rotating to:', targetRotation);

    if (elements.wheel) {
      console.log('Wheel element found, applying rotation');
      // 强制触发重绘以确保 transition 生效
      elements.wheel.offsetHeight;
      elements.wheel.style.transform = `rotate(${targetRotation}deg)`;
      console.log('Transform applied:', elements.wheel.style.transform);
    } else {
      console.log('Wheel element NOT found!');
    }

    setTimeout(() => {
      State.hasSpun = true;
      saveState();
      showResult();
    }, CONFIG.SPIN_DURATION);
  }

  function handleClose() {
    hideModal();
    State.isClosed = true;
    saveState();

    // 延迟显示浮动按钮
    setTimeout(() => {
      showFloatingBtn();
    }, 400);
  }

  // ============================================
  // 表单提交处理
  // ============================================

  function handleFormSubmit(e) {
    e.preventDefault();

    const email = elements.emailInput ? elements.emailInput.value.trim() : '';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email || !emailRegex.test(email)) {
      if (elements.emailError) {
        elements.emailError.textContent = 'Please enter a valid email address.';
        elements.emailError.classList.remove('is-hidden');
      }
      return;
    }

    if (elements.emailError) {
      elements.emailError.classList.add('is-hidden');
    }

    showSuccess();

    setTimeout(() => {
      if (elements.emailForm) elements.emailForm.submit();
    }, 1500);
  }

  /**
   * 检查表单是否刚提交成功（页面刷新后）
   */
  function checkFormSubmission() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('customer_posted') !== 'true') return;

    // 同步状态到 State
    State.hasSubmitted = true;
    State.hasSpun = true;
    saveState();

    // 显示成功提示
    const successMsg = document.querySelector('.stw-result__success');
    if (successMsg) {
      successMsg.classList.remove('is-hidden');
    }

    // 隐藏表单输入框和按钮
    const emailForm = document.getElementById('stw-email-form');
    if (emailForm) {
      const input = emailForm.querySelector('.stw-result__input');
      const submitBtn = emailForm.querySelector('.stw-result__submit');
      if (input) input.style.display = 'none';
      if (submitBtn) submitBtn.style.display = 'none';
    }
  }

  // ============================================
  // 事件绑定
  // ============================================

  function bindEvents() {
    console.log('bindEvents, spinBtn:', elements.spinBtn);
    
    if (elements.spinBtn) {
      elements.spinBtn.addEventListener('click', function(e) {
        console.log('Spin button clicked');
        handleSpin();
      });
    }

    elements.closeBtns.forEach((btn) => {
      btn.addEventListener('click', handleClose);
    });

    if (elements.floatingBtn) {
      elements.floatingBtn.addEventListener('click', (e) => {
        if (e.target.closest('.stw-floating-btn__close')) {
          hideFloatingBtn();
          return;
        }
        showModal();
        // 如果已经抽过奖，直接显示结果视图
        if (State.hasSpun) {
          if (elements.wheelView) elements.wheelView.style.opacity = '0';
          showResult();
        }
      });
    }

    if (elements.emailForm) {
      elements.emailForm.addEventListener('submit', handleFormSubmit);
    }
  }

  // ============================================
  // 渲染转盘
  // ============================================

  function renderWheelLabels() {
    const labelsContainer = document.querySelector('.stw-wheel__labels');
    const linesContainer = document.querySelector('.stw-wheel__lines');
    if (!labelsContainer || !linesContainer) return;

    const segmentCount = CONFIG.SEGMENTS.length;
    const anglePerSegment = 360 / segmentCount;

    // 获取转盘实际尺寸，动态计算中心点
    const wheelRect = labelsContainer.getBoundingClientRect();
    console.log('WheelRect:', wheelRect);
    const centerX = (wheelRect.width / 2)+10;
    const centerY = (wheelRect.height / 2)+10;
    // 转盘半径（用于计算文字位置）
    const wheelRadius = wheelRect.width / 2;
    // 文字距离中心的偏移半径（参考SVG中 x=70, 中心=50, 半径=45 的比例）
    const labelRadius = wheelRadius * 0.75;

    // 转盘背景旋转角度（与 CSS 中的 transform: rotate(60deg) 对应）
    const bgRotation = 60;

    CONFIG.SEGMENTS.forEach((segment, index) => {
      // 扇区起始角度（背景旋转前）
      const segmentStartAngle = index * anglePerSegment;
      // 扇区中心角度（背景旋转前）
      const segmentCenterAngle = segmentStartAngle + anglePerSegment / 2;
      // 考虑背景旋转后的实际角度
      const actualAngle = segmentCenterAngle + bgRotation;
      // 文字位置角度（从12点钟方向开始计算）
      const posAngleRad = (actualAngle - 90) * (Math.PI / 180);
      const x = Math.cos(posAngleRad) * labelRadius;
      const y = Math.sin(posAngleRad) * labelRadius;

      const labelEl = document.createElement('div');
      labelEl.className = 'stw-wheel__label';
      labelEl.textContent = segment.label;

      labelEl.style.left = `${centerX + x}px`;
      labelEl.style.top = `${centerY + y}px`;
      // 文字旋转：与背景旋转一致，让文字对齐扇区
      labelEl.style.transform = `translate(-50%, -50%) rotate(${actualAngle + 90}deg)`;

      labelsContainer.appendChild(labelEl);
    });

    for (let i = 0; i < segmentCount; i++) {
      const angleDeg = i * anglePerSegment + bgRotation;
      const lineEl = document.createElement('div');
      lineEl.style.position = 'absolute';
      lineEl.style.top = '50%';
      lineEl.style.left = '50%';
      lineEl.style.width = '50%';
      lineEl.style.height = '2px';
      lineEl.style.background = '#4a2c5a';
      lineEl.style.transformOrigin = '0% 50%';
      lineEl.style.transform = `rotate(${angleDeg - 90}deg)`;
      linesContainer.appendChild(lineEl);
    }
  }

  // ============================================
  // 初始化
  // ============================================

  function init() {
    console.log('init called');
    
    // 读取保存的状态
    loadState();
    console.log('State loaded:', State);

    // 获取 DOM 元素
    getElements();

    // 检查表单是否刚提交成功
    checkFormSubmission();

    // 如果已经提交过邮箱，彻底隐藏整个抽奖功能
    if (State.hasSubmitted) {
      console.log('Already submitted, hiding widget');
      return;
    }

    // 渲染转盘标签
    renderWheelLabels();

    // 绑定事件
    bindEvents();

    // 根据状态决定显示什么
    if (State.isClosed) {
      // 如果之前关闭过，直接显示浮动按钮
      showFloatingBtn();
    } else {
      // 延迟显示弹窗
      setTimeout(() => {
        showModal();

        // 如果已经抽过奖，直接显示结果视图
        if (State.hasSpun) {
          // 隐藏转盘视图，直接显示结果
          if (elements.wheelView) elements.wheelView.style.opacity = '0';
          showResult();
        } else {
          // 第一次访问，添加脉冲动画提示用户点击
          if (elements.spinBtn) {
            elements.spinBtn.classList.add('is-pulsing');
          }
        }
      }, CONFIG.SHOW_DELAY);
    }
  }

  // ============================================
  // 启动
  // ============================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();